import type { Game } from '../domain/types'

/**
 * Leaving a game without ending it.
 *
 * Two very different situations behind one control, so they get two very
 * different treatments. A game opened by accident has nothing in it and is worth
 * nobody's attention -- it closes silently. A game with taps in it represents
 * someone's evening, so it asks, states exactly how much is at stake, and makes
 * the destructive option the one you have to reach for.
 *
 * The whole app is otherwise confirmation-free by design; this is the single
 * exception, and only when there is something to lose.
 */
export function ExitGame({
  game,
  eventCount,
  opponentName,
  onKeepDraft,
  onDiscard,
  onCancel,
}: {
  game: Game
  eventCount: number
  opponentName: string
  onKeepDraft(): void
  onDiscard(): void
  onCancel(): void
}) {
  return (
    <div className="overlay">
      <div className="overlay__panel overlay__panel--narrow">
        <header className="overlay__header">
          <h2>Leave this game?</h2>
        </header>

        <p className="exit__summary">
          <strong>{eventCount}</strong> {eventCount === 1 ? 'stat' : 'stats'} recorded
          {' · '}
          {game.homeAway === 'home' ? 'vs' : '@'} {opponentName}
        </p>

        <div className="exit__choices">
          <button type="button" className="btn btn--primary exit__btn" onClick={onKeepDraft}>
            Keep as draft
            <span className="exit__hint">Resume it next time you open the app</span>
          </button>

          <button type="button" className="btn exit__btn" onClick={onCancel}>
            Cancel
            <span className="exit__hint">Go back to scoring</span>
          </button>

          <button type="button" className="btn btn--danger exit__btn" onClick={onDiscard}>
            Discard
            <span className="exit__hint">
              Deletes this game and all {eventCount} {eventCount === 1 ? 'stat' : 'stats'}
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
